import request from '@/router/axios';
//查询项目列表(带分页)
export const searchProjectPage = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectPage',
    method: 'post',
    data: data
  })
}
export const searchProjectPageV2 = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectPageV2',
    method: 'post',
    data: data
  })
}
//查询项目列表（不带分页）
export const searchProject = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProject',
    method: 'post',
    data: data
  })
}
//查询项目资源树
export const searchConfigProjectTree = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchConfigProjectTree',
    method: 'post',
    data: data
  })
}
//添加资源
export const addProject = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/addProject',
    method: 'post',
    data: data
  })
}
//修改资源
export const updateProject = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/updateProject',
    method: 'post',
    data: data
  })
}
/* 电价 */
//项目列表-查询电价组合实体列表
export const searchProjectPriceInfo = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectPriceInfo',
    method: 'post',
    data: data
  })
}
//项目列表-新增电价组合实体
export const addProjectPriceInfo = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/addProjectPriceInfo',
    method: 'post',
    data: data
  })
}
//项目列表-添加电价组合价格
export const addProjectPrice = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/addProjectPrice',
    method: 'post',
    data: data
  })
}
//项目列表-批量修改电价组合价格
export const updateBatchProjectPrice = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/updateBatchProjectPrice',
    method: 'post',
    data: data
  })
}
//项目列表-查询电价组合价格列表
export const searchProjectPrice = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectPrice',
    method: 'post',
    data: data
  })
}

//项目列表-删除电价组合价格
/* {
  "priceId": 0
} */
export const deleteProjectPrice = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/deleteProjectPrice',
    method: 'post',
    data: data
  })
}
/***导入 ***/
//项目数据点导入-查询项目EMS信息列表
/* {
  "projectId": ""
} */
export const searchProjectEms = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectEms',
    method: 'post',
    data: data
  })
}
//项目数据点导入-项目添加EMS信息
export const addProjectEms = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/addProjectEms',
    method: 'post',
    data: data
  })
}
//项目数据点导入-项目修改EMS信息
export const updateProjectEms = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/updateProjectEms',
    method: 'post',
    data: data
  })
}
//项目数据点导入-增加项目设备实体
export const addProjectEquipmentInfo = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/addProjectEquipmentInfo',
    method: 'post',
    data: data
  })
}
//项目数据点导入-修改项目设备实体
export const updateProjectEquipmentInfo = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/updateProjectEquipmentInfo',
    method: 'post',
    data: data
  })
}
//项目数据点导入-查询项目设备实体列表
export const searchProjectEquipmentInfo = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectEquipmentInfo',
    method: 'post',
    data: data
  })
}
//项目数据点导入-添加项目设备数据点实体
export const addProjectEquipmentFieldsInfo = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/addProjectEquipmentFieldsInfo',
    method: 'post',
    data: data
  })
}
//项目数据点导入-修改项目设备数据点实体
export const updateProjectEquipmentFieldsInfo = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/updateProjectEquipmentFieldsInfo',
    method: 'post',
    data: data
  })
}
//项目数据点导入-查询项目设备数据点实体列表
export const searchProjectEquipmentFieldsInfo = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectEquipmentFieldsInfo',
    method: 'post',
    data: data
  })
}
/*** 二级指标 ***/
//项目二级指标及模块配置-查询项目下指标
export const searchConfigProjectStatistics = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchConfigProjectStatistics',
    method: 'post',
    data: data
  })
}
//项目二级指标及模块配置-查询项目算法实体列表-下拉
export const searchAlgorithmEntitys = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchAlgorithmEntitys',
    method: 'post',
    data: data
  })
}
//项目二级指标及模块配置-查询项目配置计算实体
export const searchComputeConfiguration = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchComputeConfiguration',
    method: 'post',
    data: data
  })
}
//项目二级指标及模块配置-查询项目指标已配置算法参数
export const searchConfigProjectStatisticsAlgorithmParam = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchConfigProjectStatisticsAlgorithmParam',
    method: 'post',
    data: data
  })
}
//项目二级指标及模块配置-查询项目指标已配置算法触发
export const searchConfigProjectStatisticsAlgorithmTrigger = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchConfigProjectStatisticsAlgorithmTrigger',
    method: 'post',
    data: data
  })
}
/*** 页签 ***/
//新增接线图页签
export const addProjectTab = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/addProjectTab',
    method: 'post',
    data: data
  })
}
//修改接线图页签
export const updateProjectTab = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/updateProjectTab',
    method: 'post',
    data: data
  })
}
//查询接线图页签列表
export const searchProjectTabList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectTabList',
    method: 'post',
    data: data
  })
}
/*** 模板 ***/
//新增模板实体
export const addProjectTemplateInfo = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/addProjectTemplateInfo',
    method: 'post',
    data: data
  })
}
//修改模板实体
export const updateProjectTemplateInfo = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/updateProjectTemplateInfo',
    method: 'post',
    data: data
  })
}
//查询页签下模板实体
export const searchProjectTemplateInfoListByProjectIdAndTabID = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectTemplateInfoListByProjectIdAndTabID',
    method: 'post',
    data: data
  })
}
//查询项目下模板实体
export const searchProjectTemplateInfoListByProjectId = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectTemplateInfoListByProjectId',
    method: 'post',
    data: data
  })
}
/* 设备 */
//新增模板下设备
export const addProjectEquipmentLogicList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/addProjectEquipmentLogicList',
    method: 'post',
    data: data
  })
}
//修改模板下设备
export const updateProjectEquipmentLogicList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/updateProjectEquipmentLogicList',
    method: 'post',
    data: data
  })
}
//查询模板下设备列表
export const searchProjectEquipmentLogicListByTemplateId = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectEquipmentLogicListByTemplateId',
    method: 'post',
    data: data
  })
}
/* 数据点 */
//查询模板下设备列表
export const addProjectEquipmentFieldsLogicList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/addProjectEquipmentFieldsLogicList',
    method: 'post',
    data: data
  })
}
//修改模板下设备数据点
export const updateProjectEquipmentFieldsLogicList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/updateProjectEquipmentFieldsLogicList',
    method: 'post',
    data: data
  })
}
//查询模板设备下数据点列表
export const searchProjectEquipmentFieldsLogicListByEquipId = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectEquipmentFieldsLogicListByEquipId',
    method: 'post',
    data: data
  })
}
//查询项目设备实体列表
export const searchProjectEquipmentInfoByProjectId = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectEquipmentInfoByProjectId',
    method: 'post',
    data: data
  })
}
//查询项目设备实体列表
export const searchProjectEquipmentInfoByProjectIdV2 = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectEquipmentInfoByProjectIdV2',
    method: 'post',
    data: data
  })
}
//项目数据点导入-多个Excel文件导入
export const importExcelsForProjectData = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/importExcelsForProjectData',
    method: 'post',
    data: data
  })
}
//查询项目下二级指标及模块列表-调整指标显示顺序
/*
{
  "entityId": "" //项目ID
}
 */
export const searchConfigProjectStatisticsListForOrder = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchConfigProjectStatisticsListForOrder',
    method: 'post',
    data: data
  })
}
//查询ems列表
export const batterySearchEmsList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/battery/searchEmsList',
    method: 'post',
    data: data
  })
}
//查询ems下电芯配置详情
export const searchBatteryCellConfigByEMS = (data) => {
  return request({
    url: '/svolt-ess-boss-service/battery/searchBatteryCellConfigByEMS',
    method: 'get',
    params: data
  })
}
//添加ems下电芯配置
export const addBatterCellConfig = (data) => {
  return request({
    url: '/svolt-ess-boss-service/battery/addBatterCellConfig',
    method: 'post',
    data: data
  })
}
//删除ems下电芯配置
export const deleteBatteryCellConfig = (data) => {
  return request({
    url: '/svolt-ess-boss-service/battery/deleteBatteryCellConfig',
    method: 'get',
    params: data
  })
}
//查询项目热力图规则列表
export const searchRuleByProject = (data) => {
  return request({
    url: '/svolt-ess-boss-service/thermodynamic/searchRuleByProject',
    method: 'get',
    params: data
  })
}
//添加项目热力图规则
export const addRule = (data) => {
  return request({
    url: '/svolt-ess-boss-service/thermodynamic/addRule',
    method: 'post',
    data: data
  })
}
//清理接线图缓存
export const clearProjectWiringDiagramCache = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/clearProjectWiringDiagramCache',
    method: 'post',
    data: data
  })
}
//查询项目列表
export const searchProjectList = () => {
  return request({
    url: '/svolt-ess-boss-service/battery/searchProjectList',
    method: 'get',
  })
}
//查询ems导入列表
export const searchEmsImportList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/battery/searchEmsImportList',
    method: 'post',
    data: data
  })
}
//添加项目V2
export const addProjectV2 = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/addProjectV2',
    method: 'post',
    data: data
  })
}
//查询项目下设备点结构树
export const getProjectEquipmentTree = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/getProjectEquipmentTree',
    method: 'get',
    params: data
  })
}
//添加项目EMS
export const addProjectEmsV2 = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/addProjectEmsV2',
    method: 'post',
    data: data
  })
}
//添加项目设备
export const addProjectEquipmentInfoV2 = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/addProjectEquipmentInfoV2',
    method: 'post',
    data: data
  })
}
//查询项目详情
export const searchProjectDetail = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectDetail',
    method: 'get',
    params: data
  })
}
//修改项目V2
export const updateProjectV2 = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/updateProjectV2',
    method: 'post',
    data: data
  })
}
//查询项目设备详情
export const getProjectEquipmentInfo = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/getProjectEquipmentInfo',
    method: 'get',
    params: data
  })
}
//修改项目设备
export const updateProjectEquipmentInfoV2 = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/updateProjectEquipmentInfoV2',
    method: 'post',
    data: data
  })
}
//删除项目设备
export const deleteProjectEquipmentInfo = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/deleteProjectEquipmentInfo',
    method: 'get',
    params: data
  })
}
//添加项目设备点
export const addProjectEquipmentFieldsInfoV2 = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/addProjectEquipmentFieldsInfoV2',
    method: 'post',
    data: data
  })
}
//查询设备下的属性点列表
export const searchProjectEquipFields = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectEquipFields',
    method: 'get',
    params: data
  })
}
//查询项目设备点详情
export const getProjectEquipmentFieldInfo = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/getProjectEquipmentFieldInfo',
    method: 'get',
    params: data
  })
}
//修改项目设备点
export const updateProjectEquipmentFieldInfoV2 = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/updateProjectEquipmentFieldInfoV2',
    method: 'post',
    data: data
  })
}
//删除项目设备点
export const deleteProjectEquipmentFieldsInfo = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/deleteProjectEquipmentFieldsInfo',
    method: 'post',
    data: data
  })
}
//批量绑定设备
export const batchBindProjectEquipment = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/batchBindProjectEquipment',
    method: 'post',
    data: data
  })
}
//复制项目设备
export const copyProjectEquipment = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/copyProjectEquipment',
    method: 'post',
    data: data
  })
}
//根据项目编号查询面板以及绑点配置
export const searchAllPanelData = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectPanel/searchAllPanelData',
    method: 'post',
    params: data
  })
}
//模糊查询绑点数据top10
export const fuzzySearchFields = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectPanel/fuzzySearchFields',
    method: 'post',
    params: data
  })
}
//新增或修改面板绑点数据
export const saveOrUpdateSimulationPanelData = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectPanel/saveOrUpdateSimulationPanelData',
    method: 'post',
    data: data
  })
}
//根据场景获取全部面板模版
export const searchAllPanelTemplateByScene = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectPanel/searchAllPanelTemplateByScene',
    method: 'post',
    data: data
  })
}
//根据多个模板绑点数据编号和项目编号批量保存入库
export const saveAllPanelDataBySortedAndProjectId = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectPanel/saveAllPanelDataBySortedAndProjectId',
    method: 'post',
    data: data
  })
}
//查询面板和数据点
export const searchFixSimulationPanelData = (data) => {
  return request({
    url: '/svolt-ess-service/project/monitor/searchFixSimulationPanelData',
    method: 'post',
    params: data
  })
}
//查询项目下设备点结构树-虚拟设备
export const getProjectEquipmentTreeWithVirtual = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/getProjectEquipmentTreeWithVirtual',
    method: 'get',
    params: data
  })
}
//查询项目虚拟设备属性点计算逻辑配置
export const searchProjectEquipAggregationFieldsComputeLogicConfigWithVirtual = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectEquipAggregationFieldsComputeLogicConfigWithVirtual',
    method: 'get',
    params: data
  })
}
//模糊查询绑点数据
export const fuzzySearchFieldsWithFieldsId = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectPanel/fuzzySearchFieldsWithFieldsId',
    method: 'post',
    params: data
  })
}
//保存项目设备点计算逻辑配置
export const saveProjectEquipAggregationFieldsComputeLogicConfig = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/saveProjectEquipAggregationFieldsComputeLogicConfig',
    method: 'post',
    data: data
  })
}
//生效项目设备点计算逻辑配置
export const takeEffectProjectEquipAggregationFieldsComputeLogicConfig = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/takeEffectProjectEquipAggregationFieldsComputeLogicConfig',
    method: 'post',
    data: data
  })
}
//查询项目设备属性点-带系数
export const searchProjectEquipFieldsWithVirtual = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectEquipFieldsWithVirtual',
    method: 'get',
    params: data
  })
}
//保存项目设备点系数配置
export const saveProjectEquipmentFieldInfoConfig = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/saveProjectEquipmentFieldInfoConfig',
    method: 'post',
    data: data
  })
}
//生效项目设备点系数配置
export const takeEffectProjectEquipmentFieldInfoConfig = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/takeEffectProjectEquipmentFieldInfoConfig',
    method: 'post',
    data: data
  })
}
//导入ems
export const importEmsExcel = (data) => {
  return request({
    url: '/svolt-ess-boss-service/ems/importEmsExcel',
    method: 'post',
    data: data
  })
}
//本地监控-添加用户
export const addLocalUser = (data) => {
  return request({
    url: '/svolt-ess-boss-service/local/addLocalUser',
    method: 'post',
    data: data
  })
}
//本地监控-查询用户列表
export const getLocalUserList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/local/getLocalUserList',
    method: 'get',
    params: data
  })
}
//本地监控-修改用户
export const updateLocalUser = (data) => {
  return request({
    url: '/svolt-ess-boss-service/local/updateLocalUser',
    method: 'post',
    data: data
  })
}
//本地监控-删除用户
export const delLocalUser = (data) => {
  return request({
    url: '/svolt-ess-boss-service/local/delLocalUser',
    method: 'post',
    data: data
  })
}
//查询项目下点表树
export const searchFieldTreeByProject = (data) => {
  return request({
    url: '/svolt-ess-boss-service/connection/diagram/searchFieldTreeByProject',
    method: 'get',
    params: data
  })
}
//查询树节点下数据点-带权限
export const searchFieldByTree = (data) => {
  return request({
    url: '/svolt-ess-boss-service/connection/diagram/searchFieldByTree',
    method: 'get',
    params: data
  })
}
//添加遥控
export const addRemoteControl = (data) => {
  return request({
    url: '/svolt-ess-boss-service/remoteControl/addRemoteControl',
    method: 'post',
    data: data
  })
}
//查询遥控列表
export const searchRemoteControlList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/remoteControl/searchRemoteControlList',
    method: 'get',
    params: data
  })
}
//删除遥控
export const deleteRemoteControl = (data) => {
  return request({
    url: '/svolt-ess-boss-service/remoteControl/deleteRemoteControl',
    method: 'get',
    params: data
  })
}
//删除遥控点
export const deleteRemoteControlField = (data) => {
  return request({
    url: '/svolt-ess-boss-service/remoteControl/deleteRemoteControlField',
    method: 'get',
    params: data
  })
}
//本地监控-导出
export const exportProjectInfo  = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/exportProjectInfo',
    method: 'get',
    params: data
  })
}
//本地监控-查询列表
export const searchProjectLocalExports  = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/searchProjectLocalExports',
    method: 'get',
    params: data
  })
}
//查询遥调列表
export const searchRemoteTuningList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/remoteControl/searchRemoteTuningList',
    method: 'get',
    params: data
  })
}
//添加遥调
export const addRemoteTuning = (data) => {
  return request({
    url: '/svolt-ess-boss-service/remoteControl/addRemoteTuning',
    method: 'post',
    data: data
  })
}
//添加遥调
export const deleteRemoteTuning = (data) => {
  return request({
    url: '/svolt-ess-boss-service/remoteControl/deleteRemoteTuning',
    method: 'get',
    params: data
  })
}
//查询ems下点配置详情
export const searchFiledConfigByEMS = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/fields/searchFiledConfigByEMS',
    method: 'get',
    params: data
  })
}
//添加项目点配置
export const addProjectFieldsConfig = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/fields/addProjectFieldsConfig',
    method: 'post',
    data: data
  })
}
//删除ems下项目点配置
export const deleteProjectFieldsConfig = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/fields/deleteProjectFieldsConfig',
    method: 'get',
    params: data
  })
}
//元数据-查询项目数据模型配置
export const searchModelDataConfigList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectmetadatamanage/searchModelDataConfigList',
    method: 'get',
    params: data
  })
}
//元数据-更新项目数据模型配置
export const updateModelDataConfig = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectmetadatamanage/updateModelDataConfig',
    method: 'post',
    data: data
  })
}
//元数据-新增项目数据模型配置
export const addModelDataConfig = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectmetadatamanage/addModelDataConfig',
    method: 'post',
    data: data
  })
}
//元数据-批量保存项目数据模型配置列表
export const batchSaveModelDataConfigList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectmetadatamanage/batchSaveModelDataConfigList',
    method: 'post',
    data: data
  })
}
//元数据-解析点表及配置数据生成模型映射数据
export const analysisProjectDataGeneratingMetadata = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectmetadatamanage/analysisProjectDataGeneratingMetadata',
    method: 'post',
    data: data
  })
}
//缓存插箱下电芯及温度信息
export const cacheBoxWithCellAndTemp = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectmetadatamanage/cacheBoxWithCellAndTemp',
    method: 'post',
    data: data
  })
}

export default{
  searchProject,
  searchProjectPage,
  searchProjectPageV2,
  exportProjectInfo,
  searchProjectLocalExports,
  searchConfigProjectTree,
  addProject,
  updateProject,
  searchProjectPriceInfo,
  addProjectPriceInfo,
  addProjectPrice,
  updateBatchProjectPrice,
  searchProjectPrice,
  deleteProjectPrice,
  searchProjectEms,
  addProjectEms,
  updateProjectEms,
  addProjectEquipmentInfo,
  updateProjectEquipmentInfo,
  searchProjectEquipmentInfo,
  addProjectEquipmentFieldsInfo,
  updateProjectEquipmentFieldsInfo,
  searchProjectEquipmentFieldsInfo,
  searchConfigProjectStatistics,
  searchAlgorithmEntitys,
  searchComputeConfiguration,
  searchConfigProjectStatisticsAlgorithmParam,
  searchConfigProjectStatisticsAlgorithmTrigger,
  addProjectTab,
  updateProjectTab,
  searchProjectTabList,
  searchProjectTemplateInfoListByProjectIdAndTabID,
  searchProjectTemplateInfoListByProjectId,
  addProjectEquipmentLogicList,
  updateProjectEquipmentLogicList,
  searchProjectEquipmentLogicListByTemplateId,
  addProjectEquipmentFieldsLogicList,
  updateProjectEquipmentFieldsLogicList,
  searchProjectEquipmentFieldsLogicListByEquipId,
  addProjectTemplateInfo,
  updateProjectTemplateInfo,
  searchProjectEquipmentInfoByProjectId,
  searchProjectEquipmentInfoByProjectIdV2,
  importExcelsForProjectData,
  searchConfigProjectStatisticsListForOrder,
  batterySearchEmsList,
  searchBatteryCellConfigByEMS,
  addBatterCellConfig,
  deleteBatteryCellConfig,
  searchRuleByProject,
  addRule,
  clearProjectWiringDiagramCache,
  searchProjectList,
  searchEmsImportList,
  addProjectV2,
  getProjectEquipmentTree,
  addProjectEmsV2,
  addProjectEquipmentInfoV2,
  searchProjectDetail,
  updateProjectV2,
  getProjectEquipmentInfo,
  updateProjectEquipmentInfoV2,
  deleteProjectEquipmentInfo,
  addProjectEquipmentFieldsInfoV2,
  searchProjectEquipFields,
  getProjectEquipmentFieldInfo,
  updateProjectEquipmentFieldInfoV2,
  deleteProjectEquipmentFieldsInfo,
  batchBindProjectEquipment,
  copyProjectEquipment,
  searchAllPanelData,
  fuzzySearchFields,
  saveOrUpdateSimulationPanelData,
  searchAllPanelTemplateByScene,
  saveAllPanelDataBySortedAndProjectId,
  searchFixSimulationPanelData,
  getProjectEquipmentTreeWithVirtual,
  searchProjectEquipAggregationFieldsComputeLogicConfigWithVirtual,
  fuzzySearchFieldsWithFieldsId,
  saveProjectEquipAggregationFieldsComputeLogicConfig,
  takeEffectProjectEquipAggregationFieldsComputeLogicConfig,
  searchProjectEquipFieldsWithVirtual,
  saveProjectEquipmentFieldInfoConfig,
  takeEffectProjectEquipmentFieldInfoConfig,
  importEmsExcel,
  addLocalUser,
  getLocalUserList,
  updateLocalUser,
  delLocalUser,
  searchFieldTreeByProject,
  searchFieldByTree,
  addRemoteControl,
  searchRemoteControlList,
  deleteRemoteControl,
  deleteRemoteControlField,
  searchRemoteTuningList,
  addRemoteTuning,
  deleteRemoteTuning,
  searchFiledConfigByEMS,
  addProjectFieldsConfig,
  deleteProjectFieldsConfig,
  searchModelDataConfigList,
  updateModelDataConfig,
  addModelDataConfig,
  batchSaveModelDataConfigList,
  analysisProjectDataGeneratingMetadata,
  cacheBoxWithCellAndTemp
}



// WEBPACK FOOTER //
// ./src/api/project.js